/**
 * A section's tab icon, from the Lucide name the SERVER returned (f2.1).
 *
 * Keyed by ICON NAME, never by section code: a section added by a later phase
 * names its own icon in its migration, and this file does not need to know the
 * section exists. A name outside the set below -- or no name at all -- renders
 * the default icon, so a backend-only deployment can never blank the tab strip.
 *
 * Deliberately a curated set rather than every icon Lucide ships: resolving an
 * arbitrary name at runtime would pull all ~1,500 icons into the bundle (or
 * emit one chunk per icon) for a strip that shows four. Supporting a new name
 * is one line here; forgetting to costs a default icon, never a broken screen.
 */

import {
  Bell,
  Briefcase,
  CalendarDays,
  Clock,
  Database,
  FileText,
  Gauge,
  Globe,
  Layers,
  Lock,
  Mail,
  Network,
  Palette,
  ScrollText,
  Settings,
  Shield,
  SlidersHorizontal,
  Upload,
  UploadCloud,
  Users,
  type LucideIcon,
} from 'lucide-react';

const ICONS_BY_NAME: Readonly<Record<string, LucideIcon>> = {
  bell: Bell,
  briefcase: Briefcase,
  'calendar-days': CalendarDays,
  clock: Clock,
  database: Database,
  'file-text': FileText,
  gauge: Gauge,
  globe: Globe,
  layers: Layers,
  lock: Lock,
  mail: Mail,
  network: Network,
  palette: Palette,
  'scroll-text': ScrollText,
  settings: Settings,
  shield: Shield,
  'sliders-horizontal': SlidersHorizontal,
  upload: Upload,
  'upload-cloud': UploadCloud,
  users: Users,
};

export const DEFAULT_SECTION_ICON: LucideIcon = SlidersHorizontal;

export function sectionIcon(name: string | null | undefined): LucideIcon {
  if (!name) return DEFAULT_SECTION_ICON;
  return ICONS_BY_NAME[name] ?? DEFAULT_SECTION_ICON;
}
